var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.217c0 .433-.35.783-.782.783H2.283a.783.783 0 0 1-.783-.783V4.846c0-.208.083-.407.23-.554L4.791 1.23A.782.782 0 0 1 5.346 1h13.372c.432 0 .782.35.782.783v16.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63 10.391h11.74c.432 0 .782.35.782.783V19H3.848v-7.826c0-.432.35-.783.782-.783zM5.413 1h10.174v4.696c0 .432-.35.782-.783.782H6.196a.783.783 0 0 1-.783-.782V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.457 2.565h1.565v2.348h-1.565zM6.196 12.739h5.087M6.196 15.087h8.608"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.4144d2b2bce6cc7d62e6b2b4f66c8d77.svg";
export { ForwardRef as ReactComponent };